import * as React from "react";

interface IProps {
  align?: "left" | "center" | "right";
}

const alignments = {
  center: "items-center text-center",
  left: "items-start text-left",
  right: "items-end text-right"
};

const DataMissing = (props: IProps) => {
  const alignment = props.align ? props.align : 'center'
  return (
    <div className={`font-bold text-grey flex flex-col justify-center ${alignments[alignment]}`}>
      Data unavailable
    </div>
  );
};

export default DataMissing;



// WEBPACK FOOTER //
// ./src/components/general/DataMissing.tsx